import { render, staticRenderFns } from "./JokuSituationDraftButton.vue?vue&type=template&id=06619ca1&scoped=true"
import script from "./JokuSituationDraftButton.vue?vue&type=script&lang=js"
export * from "./JokuSituationDraftButton.vue?vue&type=script&lang=js"
import style0 from "./JokuSituationDraftButton.vue?vue&type=style&index=0&id=06619ca1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06619ca1",
  null
  
)

export default component.exports